var exports = {
  "zr": "ScreenSharePickerModal.module__root___YVBtQV",
  "XV": "ScreenSharePickerModal.module__topBar___YVBtQV",
  "vR": "ScreenSharePickerModal.module__tabs___YVBtQV",
  "Gn": "ScreenSharePickerModal.module__tabLabel___YVBtQV",
  "Ll": "ScreenSharePickerModal.module__tabIcon___YVBtQV",
  "Qs": "ScreenSharePickerModal.module__content___YVBtQV",
  "Vg": "ScreenSharePickerModal.module__grid___YVBtQV",
  "Nr": "ScreenSharePickerModal.module__card___YVBtQV",
  "e5": "ScreenSharePickerModal.module__cardPending___YVBtQV",
  "VH": "ScreenSharePickerModal.module__preview___YVBtQV",
  "np": "ScreenSharePickerModal.module__previewDevice___YVBtQV",
  "Gh": "ScreenSharePickerModal.module__cardSelected___YVBtQV",
  "oz": "ScreenSharePickerModal.module__previewImage___YVBtQV",
  "yQ": "ScreenSharePickerModal.module__devicePreviewVideo___YVBtQV",
  "A3": "ScreenSharePickerModal.module__previewPlaceholder___YVBtQV",
  "Cd": "ScreenSharePickerModal.module__devicePreviewPlaceholder___YVBtQV",
  "mP": "ScreenSharePickerModal.module__previewIcon___YVBtQV",
  "rP": "ScreenSharePickerModal.module__previewOverlay___YVBtQV",
  "H5": "ScreenSharePickerModal.module__previewAction___YVBtQV",
  "zI": "ScreenSharePickerModal.module__cardBody___YVBtQV",
  "Dm": "ScreenSharePickerModal.module__cardSourceIcon___YVBtQV",
  "gL": "ScreenSharePickerModal.module__cardSourceIconImage___YVBtQV",
  "JJ": "ScreenSharePickerModal.module__cardTitle___YVBtQV",
  "wk": "ScreenSharePickerModal.module__state___YVBtQV",
  "Ml": "ScreenSharePickerModal.module__loadingState___YVBtQV",
  "hZ": "ScreenSharePickerModal.module__stateIcon___YVBtQV",
  "CY": "ScreenSharePickerModal.module__stateHeading___YVBtQV",
  "_A": "ScreenSharePickerModal.module__stateTitle___YVBtQV",
  "tM": "ScreenSharePickerModal.module__stateActions___YVBtQV",
  "xj": "ScreenSharePickerModal.module__osNotice___YVBtQV",
  "Hr": "ScreenSharePickerModal.module__downloadCta___YVBtQV",
  "wN": "ScreenSharePickerModal.module__downloadCopy___YVBtQV",
  "z5": "ScreenSharePickerModal.module__downloadTitle___YVBtQV",
  "h": "ScreenSharePickerModal.module__downloadDescription___YVBtQV",
  "qm": "ScreenSharePickerModal.module__downloadActions___YVBtQV",
  "aQ": "ScreenSharePickerModal.module__platformIcons___YVBtQV",
  "tV": "ScreenSharePickerModal.module__platformIcon___YVBtQV",
  "qr": "ScreenSharePickerModal.module__footer___YVBtQV",
  "wu": "ScreenSharePickerModal.module__footerStart___YVBtQV",
  "vM": "ScreenSharePickerModal.module__streamSummary___YVBtQV",
  "ru": "ScreenSharePickerModal.module__streamSummaryTitle___YVBtQV",
  "$o": "ScreenSharePickerModal.module__streamSummaryDetails___YVBtQV",
  "sw": "ScreenSharePickerModal.module__streamSummaryDetail___YVBtQV",
  "Xd": "ScreenSharePickerModal.module__streamButton___YVBtQV",
  "ZF": "ScreenSharePickerModal.module__previewNotice___YVBtQV",
  "cP": "ScreenSharePickerModal.module__previewNoticeText___YVBtQV",
  "vw": "ScreenSharePickerModal.module__previewNoticeInfoButton___YVBtQV",
  "Ip": "ScreenSharePickerModal.module__previewInfoContent___YVBtQV",
  "Jh": "ScreenSharePickerModal.module__previewInfoParagraph___YVBtQV",
  "NZ": "ScreenSharePickerModal.module__previewInfoSwitch___YVBtQV",
};

module.exports = exports;
